import { Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

export function DetailRow({ label, value }: DetailRowProps) {
  return (
    <Stack spacing={4} sx={{ minWidth: 0 }}>
      <Text size="xs" color="dimmed" tt="uppercase" sx={{ letterSpacing: 0.4 }}>
        {label}
      </Text>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Text size="sm">{value}</Text>
      ) : (
        value
      )}
    </Stack>
  );
}
